import { render, staticRenderFns } from "./SubscriptionAlert.vue?vue&type=template&id=2d7aef5b&"
import script from "./SubscriptionAlert.vue?vue&type=script&lang=js&"
export * from "./SubscriptionAlert.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionAlert.vue?vue&type=style&index=0&id=2d7aef5b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports